/* BTKExtraDiscount: the JS twin of snippets/btk-extra-discount.liquid, for the
   places that read RAW Shopify prices (/products/<handle>.js), which the
   Liquid change cannot reach.

   The extra discount is a Shopify automatic discount taken at checkout. A copy
   lives in the shop metafield btk.extra_discounts, inlined by layout/theme.liquid
   as window.BTKExtraDiscountsConfig. Same rules as the Liquid snippet:
   - eligible by product TAG (smart collections are tag-driven);
   - only live between starts_at and ends_at;
   - the highest percent wins, never two stacked (Shopify applies the best one);
   - now = price - round(price x percent / 100), was = compare-at if above
     price, else price. All money in pence.
   flagHtml() must stay identical to snippets/btk-extra-discount-flag.liquid. */
(function () {
  'use strict';

  function cfg() {
    var c = window.BTKExtraDiscountsConfig;
    return (c && Array.isArray(c.discounts)) ? c : null;
  }

  function isLive(d, nowMs) {
    if (d.starts_at) { var s = Date.parse(d.starts_at); if (!isNaN(s) && s > nowMs) return false; }
    if (d.ends_at) { var e = Date.parse(d.ends_at); if (!isNaN(e) && e <= nowMs) return false; }
    return true;
  }

  // The best live discount for a product's tags: { index, title, percent } or null.
  function forTags(tags) {
    var c = cfg();
    if (!c) return null;
    var have = {};
    (Array.isArray(tags) ? tags : String(tags || '').split(','))
      .forEach(function (t) { t = String(t).trim(); if (t) have[t] = true; });
    var nowMs = Date.now();
    var best = null;
    c.discounts.forEach(function (d, i) {
      var pct = Number(d && d.percent) || 0;
      if (!(pct > 0 && pct < 100) || (best && pct <= best.percent) || !isLive(d, nowMs)) return;
      if (d.all === true || (d.tags || []).some(function (t) { return have[t]; })) {
        best = { index: i, title: String(d.title || ''), percent: pct };
      }
    });
    return best;
  }

  function nowCents(cents, pct) {
    cents = Number(cents) || 0;
    return pct > 0 ? cents - Math.round(cents * pct / 100) : cents;
  }
  function wasCents(cents, compareCents) {
    cents = Number(cents) || 0;
    var c = Number(compareCents) || 0;
    return c > cents ? c : cents;
  }

  // Rewrite a /products/<handle>.js product in place so price and
  // compare_at_price (and each variant's) carry the discount. Returns the
  // discount applied, or null. Safe to call twice: it marks the product.
  function applyToProduct(p) {
    if (!p || p._btkXd !== undefined) return p ? p._btkXd : null;
    var d = forTags(p.tags);
    p._btkXd = d;
    if (!d) return null;
    var fix = function (o) {
      if (!o || typeof o.price !== 'number') return;
      var was = wasCents(o.price, o.compare_at_price);
      o.price = nowCents(o.price, d.percent);
      o.compare_at_price = was;
    };
    fix(p);
    (p.variants || []).forEach(fix);
    if (typeof p.price_min === 'number') p.price_min = nowCents(p.price_min, d.percent);
    if (typeof p.price_max === 'number') p.price_max = nowCents(p.price_max, d.percent);
    return d;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  // Wording rule (see the Liquid flag): the price shown ALREADY includes it.
  function flagHtml(d) {
    if (!d) return '';
    return '<div class="btk-xd-flag" title="The price shown already includes ' + esc(d.title)
      + '. You\'ll see it listed as a saving at checkout.">'
      + '<svg class="btk-xd-flag__icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
      + '<span>Extra ' + esc(d.percent) + '% off included</span></div>';
  }

  // A discount by its index in the config (the `xd` the planner catalogue carries).
  function byIndex(i) {
    var c = cfg();
    var d = c && c.discounts[i];
    return d ? { index: i, title: String(d.title || ''), percent: Number(d.percent) || 0 } : null;
  }

  window.BTKExtraDiscount = {
    forTags: forTags, byIndex: byIndex, nowCents: nowCents, wasCents: wasCents,
    applyToProduct: applyToProduct, flagHtml: flagHtml,
  };
})();
